import React from 'react';
import { CheckIcon, RulerIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['Garantía de 7 días', 'Pago seguro', 'Acceso inmediato', 'Pagás en USD', 'Material listo para usar desde hoy'];
export function FinalCta() {
  return <section className="bg-stage-deep contour py-16 sm:py-20" aria-labelledby="final-title" data-id="element-70" data-mp="1jcd94n8o4mic">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-71" data-mp="1eettbiwbo1oa">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-yellow" data-id="element-72" data-mp="1ec7klfxp3g4h">
          <RulerIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="1o43leyr61kce" /> {productName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-74" data-mp="223mfwor20x68">
          Hecho por especialistas, para docentes de Latinoamérica
        </h2>

        <Countdown light className="mt-8" data-id="element-75" data-mp="n5m8m8upag51" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border-2 border-yellow bg-white p-6 text-left shadow-lift sm:flex-row sm:items-center sm:justify-between" data-id="element-76" data-mp="n6w6oy1jzobo">
          <p data-id="element-77" data-mp="x390rx10g46y">
            <b className="block text-sm uppercase leading-tight text-ink" data-id="element-78" data-mp="x3iofdyl1z9h">{productName}</b>
            <span className="text-sm text-muted" data-id="element-79" data-mp="12354rw9pjvmi">
              {totalVolumes} tomos + {totalBonuses} bonos · Acceso inmediato
            </span>
          </p>
          <div className="sm:text-right" data-id="element-80" data-mp="162mbet0veyt9">
            <p className="text-sm text-muted" data-id="element-81" data-mp="1b2rtpil938yo">
              <span className="mr-2 line-through" data-id="element-82" data-mp="1b1gs9pfa2daq">{priceBefore}</span>
              <b className="text-base text-ink" data-id="element-83" data-mp="1fvkyg6gpyhar">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-84" data-mp="1ktwckte1rdys">
              Quiero mi Mega Pack ahora
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-85" data-mp="1ttj9b1vtzvli">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="3qv73yl3ekqb1">
              <CheckIcon className="h-4 w-4 text-green" aria-hidden="true" data-id="element-87" data-mp="3lwneiaplowdx" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}